import {Component, HostBinding, OnInit} from '@angular/core';
import {OfflineUnitsService} from './offline-units.service';

@Component({
  selector: 'app-offline-units',
  templateUrl: './offline-units.component.html',
})
export class OfflineUnitsComponent  {
  @HostBinding('class.header-menu-item') offlineUnitsComponent = true;
  constructor(
    public offlineUnitsService: OfflineUnitsService,
  ) { }
}
